<div class="header bold">
  {{ day.specificDay }}
</div>
<div *ngFor="let item of day.timelineGroup; let i = index; trackBy: trackByIndex">
  <app-timeline-detail-item [item]="item" [isChaseTimeline]="isChaseTimeline" [index]="i"></app-timeline-detail-item>
</div>
